import React from 'react';
import { motion } from 'framer-motion';
const comparisons = [{
  sit: 'No tenés logo ni identidad visual',
  sin: 'Publicás sin marca, nadie te recuerda',
  con: 'Logo profesional en 30 min con Canva. Paleta de 3 colores definida.'
}, {
  sit: 'Tus fotos no generan pedidos',
  sin: 'Foto con flash y fondo sucio. 0 comentarios.',
  con: 'Setup fotográfico costo $0 + edición en 30 segundos. Fotos que dan hambre.'
}, {
  sit: 'No sabés cómo presentar el menú',
  sin: 'Mandás una lista de texto por WhatsApp',
  con: 'Catálogo PDF interactivo de 4 páginas listo para enviar'
}, {
  sit: 'Todos tus productos se venden igual',
  sin: 'Sin estrategia. Ganás lo mismo siempre.',
  con: 'Método Gancho vs Estrella aplicado. Ticket promedio +30%'
}, {
  sit: 'Respondés lo mismo 30 veces por semana',
  sin: '2 horas diarias pegado al celular',
  con: '10 Respuestas Rápidas que se activan con /comando. 2 horas semanales ahorradas.'
}, {
  sit: 'Querés vender en kioscos y cafeterías',
  sin: 'No sabés cómo entrar ni qué decir',
  con: 'Guion de consignación que el kiosquero no puede rechazar'
}];
export function MarcaGourmetComparison() {
  return <section className="py-10 px-4 bg-white border-y border-cream-dark pt-[10px] pb-[10px]" data-id="element-167">
      <div className="max-w-5xl mx-auto" data-id="element-168">
        <div className="text-center mb-12" data-id="element-169">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-serif" data-id="element-170">
            🕊️ ¿QUÉ AGREGA EL KIT MARCA GOURMET?
          </h2>
        </div>

        <div className="overflow-x-auto pb-4" data-id="element-171">
          <table className="w-full min-w-[800px] border-collapse" data-id="element-172">
            <thead data-id="element-173">
              <tr className="bg-cream-light border-b-2 border-cream-dark" data-id="element-174">
                <th className="text-left p-4 font-bold text-carbon w-1/3" data-id="element-175">
                  Situación en tu negocio
                </th>
                <th className="text-left p-4 font-bold text-red-700 w-1/3 bg-red-50/50" data-id="element-176">
                  ❌ Sin Kit
                </th>
                <th className="text-left p-4 font-bold text-brand-green w-1/3 bg-brand-green/5" data-id="element-177">
                  ✅ Con Kit
                </th>
              </tr>
            </thead>
            <tbody data-id="element-178">
              {comparisons.map((row, i) => <motion.tr key={i} initial={{
              opacity: 0
            }} whileInView={{
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.05
            }} className="border-b border-cream-dark hover:bg-cream-light/50 transition-colors" data-id="element-179">
                  <td className="p-4 text-sm font-medium text-carbon" data-id="element-180">
                    {row.sit}
                  </td>
                  <td className="p-4 text-sm text-carbon-lighter bg-red-50/20" data-id="element-181">
                    {row.sin}
                  </td>
                  <td className="p-4 text-sm text-carbon font-medium bg-brand-green/5" data-id="element-182">
                    {row.con}
                  </td>
                </motion.tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}